(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.matchMedia('(max-width: 1024px)').matches) return;

  function init() {
    var blocks = document.querySelectorAll('.group-block.multicolumn_column');
    if (!blocks.length) return;

    var items = [];
    blocks.forEach(function (block) {
      var media = block.querySelector('.group-block__media-wrapper');
      if (!media) return;
      // Disable AOS on these blocks for mobile
      block.removeAttribute('data-aos');
      block.removeAttribute('data-aos-delay');
      block.removeAttribute('data-aos-duration');
      block.removeAttribute('data-aos-easing');
      block.removeAttribute('data-aos-offset');
      items.push({ block: block, media: media });
    });

    if (!items.length) return;

    function onScroll() {
      var vh = window.innerHeight;
      items.forEach(function (item) {
        var rect = item.block.getBoundingClientRect();

        // Not in viewport — skip
        if (rect.top >= vh || rect.bottom <= 0) return;

        // progress 0 → block is 3/4 visible (top quarter still below viewport)
        // progress 1 → block top is at 25% from viewport top
        var h = rect.height;
        var start = vh - h * 0.65;
        var end = vh < 575 ? vh * 0.01 : vh * 0.18;
        var progress = (start - rect.top) / (start - end);
        progress = Math.max(0, Math.min(1, progress));

        item.media.style.transform = 'translateY(' + (-progress * 100) + '%)';
      });
    }


    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
